"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _config = _interopRequireDefault(require("../../config"));
var _TickerComponent = _interopRequireDefault(require("./TickerComponent"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var level1 = state.apexCore.level1;
  var manifest = state.productManifest.manifest;
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  return {
    icons: manifest,
    instruments: instruments,
    level1: level1,
    show24HrPxChange: _config["default"].TickerData.show24HrPxChange,
    show24HrVolume: _config["default"].TickerData.show24HrVolume
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, null)(_TickerComponent["default"]);